<!--
* @description  参数1
* @fileName  quote
* @author userName
* @date 2024-01-29 15:31:14
!-->
<template>
  <div id="quote" class="quote">
    <div class="list-card">
      <!-- 门起运 -->
      <div v-if="data.ServiceType == 1 || data.ServiceType == 2">
        <div class="card-title">
          <span>{{ `${data.startCityNameEn},${data.startCityZipCode}>${data.shipPortCode}` }}</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用名称</td>
              <td>费用描述</td>
              <td>数量</td>
              <td>单价</td>
              <td>总价</td>
            </tr>
            <tr v-if="data.pickupAmount > 0">
              <td>提货费</td>
              <td>提货费</td>
              <td>-</td>
              <td>1</td>
              <td>CNY{{ data.pickupAmount }}</td>
              <td>CNY{{ data.pickupAmount }}</td>
            </tr>
            <tr v-if="data.startLiftgateAmount > 0">
              <td>升降机</td>
              <td>升降机费用</td>
              <td>平台费用</td>
              <td>1</td>
              <td>CNY{{ data.startLiftgateAmount }}</td>
              <td>CNY{{ data.startLiftgateAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY{{ pickupFeeSum() }}</span>
        </div>
      </div>
      <div v-if="originFeeList()">
        <div class="card-title">
          <span>起运地费用</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用名称</td>
              <td>费用描述</td>
              <td>数量</td>
              <td>单价</td>
              <td>总价</td>
            </tr>
            <tr v-for="feeItem in originFeeList()" :key="feeItem">
              <td>{{ feeItem.FeeNameEn }}</td>
              <td>{{ feeItem.FeeNameEn }}</td>
              <td>{{ feeItem.FeeNameEn }}</td>
              <td>{{ feeItem.Quanlity }}</td>
              <td>CNY{{ feeItem.UnitPrice }}</td>
              <td>CNY{{ feeItem.Amount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY{{ originSumFee() }}</span>
        </div>
      </div>
      <!-- 空运运费 -->
      <div>
        <div class="card-title">
          <span>{{ data.shipPortCode }}-{{ data.destPortCode }}</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用名称</td>
              <td>费用描述</td>
              <td>数量</td>
              <td>单价</td>
              <td>总价</td>
            </tr>
            <tr>
              <td>海运运费</td>
              <td>海运运费</td>
              <td>海运运费</td>
              <td>{{ data.chargeWeight }}</td>
              <td>CNY{{ data.costPrice }}</td>
              <td>CNY{{ data.costAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY{{ data.costAmount }}</span>
        </div>

      </div>
      <!-- 目的地费用 -->
      <div v-if="filteredDestFeeList()">
        <div class="card-title">
          <span>目的地费用</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用名称</td>
              <td>费用描述</td>
              <td>数量</td>
              <td>单价</td>
              <td>总价</td>
            </tr>
            <tr v-for="(destFeeItem, destFeeIndex) in filteredDestFeeList()" :key="destFeeIndex">
              <td>{{ destFeeItem.FeeNameEn }}</td>
              <td>{{ destFeeItem.FeeNameEn }}</td>
              <td>{{ destFeeItem.FeeNameEn }}</td>
              <td>{{ destFeeItem.Quanlity }}</td>
              <td>CNY{{ destFeeItem.UnitPrice }}</td>
              <td>CNY{{ destFeeItem.Amount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY{{ destFeeSum() }}</span>
        </div>
      </div>
      <div v-if="(data.ServiceType == 1 || data.ServiceType == 4)">
        <div class="card-title">
          <span>{{ `${data.destPortCode}>${data.destCityNameEn},${data.destCityZipCode}`
          }}</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用名称</td>
              <td>费用描述</td>
              <td>数量</td>
              <td>单价</td>
              <td>总价</td>
            </tr>
            <tr v-if="data.deliveryAmount > 0">
              <td>海运目的地费用</td>
              <td>海运目的地费用</td>
              <td>海运目的地费用</td>
              <td>1</td>
              <td>CNY{{ data.deliveryAmount }}</td>
              <td>CNY{{ data.deliveryAmount }}</td>
            </tr>
            <tr v-if="data.destLiftgateAmount > 0">
              <td>升降机</td>
              <td>升降机费用</td>
              <td>平台费用</td>
              <td>1</td>
              <td>CNY{{ data.destLiftgateAmount }}</td>
              <td>CNY{{ data.destLiftgateAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY{{ destFeeUesdSum() }}</span>
        </div>
      </div>
      <div v-if="data.isCustomsBrokerage">
        <div class="card-title">
          <span>目的地报关费用</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用描述</td>
              <td>金额</td>
            </tr>
            <tr v-for="( item, index ) in usedDestFeeList() " :key="index">
              <td>{{ item.FeeNameEn }}
              </td>
              <td>{{ item.FeeNameEn }}</td>
              <td>CNY{{ item.Amount }}</td>
            </tr>
            <tr v-if="data.bondAmount > 0">
              <td>{{ data.bondType===1?'单次有效bond(货值 USD '+data.totalValue+')':'按年购买bond' }}
              </td>
              <td>-</td>
              <td>CNY{{ data.bondAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY{{ customsFeeSum() }}</span>
        </div>
      </div>
      <!-- 保险 -->
      <div v-if="data.isrInsurance">
        <div class="card-title">
          <span>保险费</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>费用编码</td>
              <td>费用描述</td>
              <td>金额</td>
            </tr>
            <tr>
              <td>保险费 (货值 USD {{ data.totalValue }})</td>
              <td>-</td>
              <td>CNY{{ data.insuranceAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>合计: CNY{{ data.insuranceAmount }}</span>
        </div>
      </div>
      <div class="card-total">
        <span>总费用: CNY{{ data.totalAmount }}</span>
      </div>
      <div class="card-remarks">
        <p>服务说明</p>
        <slot v-for="item in data.channelDetail">
          <p>{{ item.moduleName }}:</p>
          <span>
            {{ item.content }}
          </span>
        </slot>

      </div>
    </div>

  </div>
  </div>
</template>

<script>
export default {
  name: 'Quote',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {}
    }
  },
  computed: {
    // 计算属性

  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    init(data) {
      this.data = data
    },
    filteredDestFeeList() {
      if (this.data.feeList == null) return
      return this.data.feeList.filter(item => item.FeeType == 3)
    },
    destFeeSum() {
      var list = this.filteredDestFeeList()
      if (list) {
        return list.reduce((accumulator, item) => accumulator + item.Amount, 0).toFixed(3)
      } else {
        return 0
      }
    },
    usedDestFeeList() {
      if (this.data.feeList == null) return
      return this.data.feeList.filter(fee => fee.FeeType == 4)
    },
    destFeeUesdSum() {
      return (parseFloat(this.data.deliveryAmount) + parseFloat(this.data.destLiftgateAmount)).toFixed(3)
    },
    customsFeeSum() {
      var customsFee = 0
      var customsFeeList = this.usedDestFeeList()
      if (customsFeeList) {
        customsFee = parseFloat(customsFeeList.reduce((accumulator, customsFee) => accumulator +
          customsFee.Amount, 0))
      }
      return (parseFloat(this.data.bondAmount) + customsFee).toFixed(3)
    },
    originFeeList() {
      if (this.data.feeList == null) return
      return this.data.feeList.filter(fee => fee.FeeType == 2)
    },
    originSumFee() {
      var list = this.originFeeList()
      if (list) {
        return list.reduce((accumulator, customsFee) => accumulator + customsFee.Amount, 0).toFixed(3)
      } else {
        return 0
      }
    },
    pickupFeeSum() {
      var amount = 0
      if (this.data.startLiftgateAmoun > 0) {
        amount = parseFloat(this.data.startLiftgateAmount)
      }
      if (this.data.pickupAmount > 0) {
        amount += parseFloat(this.data.pickupAmount)
      }
      return amount
    }
  }
}
</script>
<style scoped lang='scss'>
.quote {
  width: 1152px;
  height: auto;
  background: #FFFFFF;
  border-radius: 8px;
  margin-top: 16px;
  padding: 24px;

  .list-card {
    .card-title {
      width: 100%;
      height: 40px;
      background: rgba(170, 170, 170, 0.08);
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
      text-align: left;

      span {
        margin-left: 16px;
      }
    }

    .card-table {
      table {
        width: 100%;
        border-collapse: collapse;
        text-align: left;
        padding: 0 8px;

        tr:nth-of-type(1) {
          td {
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 550;
            color: #333333;
          }
        }

        tr {
          height: 40px;

          td {
            border-bottom: 1px solid rgba(170, 170, 170, 0.24);
            font-size: 13px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
            padding: 0 16px;
          }

          td:last-child {
            text-align: right;
          }
        }
      }
    }

    .card-subtotal {
      font-size: 14px;
      font-family: D-DINExp, D-DINExp;
      font-weight: bold;
      color: #333333;
      height: 40px;
      line-height: 40px;
      text-align: right;
      padding-right: 16px;
    }

    .card-total {
      height: 40px;
      line-height: 40px;
      text-align: right;
      background: rgba(2, 127, 252, 0.08);
      font-size: 16px;
      font-family: D-DINExp, D-DINExp;
      font-weight: bold;
      color: #333333;
      padding-right: 16px;
    }

    .card-remarks {
      width: 100%;
      height: 161px;
      background: rgba(0, 0, 0, 0.02);
      border-radius: 8px;
      margin: 16px 0;
      text-align: left;
      overflow-y: scroll;

      p {
        padding: 4px 8px;
        margin: 0;
      }

      span {
        padding: 0 8px;
        display: block;
      }
    }
  }
}
</style>
